import useAppManifest from "./use-app-manifest"
import { useRoute } from "./use-route"
import { AnyTab, getTabFromRoute } from "../navigation/routes"

export function useAppTab<T extends AnyTab>(): T {
  const manifest = useAppManifest()
  const route = useRoute()
  return getTabFromRoute(route, manifest) as T
}
